import React, { Component } from 'react';
import './MediaViewer.css';

export default class MediaViewer extends Component {

    constructor(props) {
        super(props);
        //console.log("MediaViewer props:", props.data);
        this.state = {
            data: props.data,
            activeElement: 0,
            activeGallery: 0,
            zoom: 1,
            zoomActive: false,
            positionX: 50,
            positionY: 50,
            changeX: 0,
            deltaX: 0,
            changeY: 0,
            deltaY: 0,
            moveActive: false,
            zoomSpeed: 0.15,
            fullscreen: false
        }
        // console.log("MediaViewer data:", this.state.data);
    }

    render() {

        const musicLabel = window.location.href.indexOf("/en/") > -1 ? "Music notes" : "Partytury";

        let mousePositionX= 0;
        let mousePositionY= 0;
        let deltaMousePositionX = 0;
        let deltaMousePositionY = 0;

        const prevImg = () => {
            this.setState({
                ...this.state,
                activeElement: this.state.activeElement - 1,
                zoom: 1,
            })
        }

        const nextImg = () => {
            this.setState({
                ...this.state,
                activeElement: this.state.activeElement + 1,
                zoom: 1,
            })
            //console.log(this.state.activeElement);
        }

        const changePhoto = imageKey => {
            this.setState({
                ...this.state,
                activeElement: imageKey,
                zoom: 1,
            })
            // console.log("IMAGE KEY TO:", imageKey);
        }
        //console.log(this.props.data ,"this.props.data")
        const mainPhotoUrl = this.props.data.gallery !== null
            ? this.props.data.gallery.images.length > 0
                ? this.state.data.gallery.images[this.state.activeElement].image
                : ""
            : "";

        const resizeImage = e => {
            document.getElementsByTagName("body")[0].style.overflow = "hidden";

            if(e.deltaY > 0){
                this.setState({
                    ...this.state,
                    zoom: this.state.zoom - this.state.zoomSpeed
                })
            } else {
                this.setState({
                    ...this.state,
                    zoom: this.state.zoom + this.state.zoomSpeed
                })
            }
        }

        const endResizeImage = () => {
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        }

        const zoomIn = () => {
            this.setState({
                ...this.state,
                zoom: this.state.zoom + this.state.zoomSpeed*5
            })
        }

        const zoomOut = () => {
            this.setState({
                ...this.state,
                zoom: this.state.zoom - this.state.zoomSpeed*5
            })
        }

        const zoomReset = () => {
            this.setState({
                ...this.state,
                zoom: 1,
                positionX: 50,
                positionY: 50,
                mousePositionX: false,
                mousePositionY: false,
                changeX: 0,
                changeY: 0,
            })
        }

        const movingImage = e => {
            if(this.state.moveActive){
                deltaMousePositionX = mousePositionX - e.clientX;
                deltaMousePositionY = mousePositionY - e.clientY;
                // console.log(deltaMousePositionX, deltaMousePositionY);
                this.setState({
                    changeX: this.state.deltaX + deltaMousePositionX,
                    changeY: this.state.deltaY + deltaMousePositionY,
                });
            }
        }

        const setInitialHandler = (x, y) => {
            mousePositionX = x;
            mousePositionY = y;
        }

        const startMovingImage = (e) => {
            this.setState({
                moveActive: true
            });
            // console.log("startMovingImage: elem to =>", e);
            setInitialHandler(e.clientX, e.clientY);
            document.getElementById("zoom-image").addEventListener("mousemove", movingImage)
        }

        const stopMovingImage = (e) => {
            this.setState({
                moveActive: false
            });
            this.state.deltaX = this.state.changeX;
            this.state.deltaY = this.state.changeY;
            // console.log("stopMovingImage: elem to =>", e);
            document.getElementById("zoom-image").removeEventListener("mousemove", movingImage)
        }

        const toggleFullscreen = () => {
            this.setState({
                fullscreen: !this.state.fullscreen
            })

            const elem = document.documentElement;

            if(!this.state.fullscreen){
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.mozRequestFullScreen) { /* Firefox */
                    elem.mozRequestFullScreen();
                } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                    elem.webkitRequestFullscreen();
                } else if (elem.msRequestFullscreen) { /* IE/Edge */
                    elem.msRequestFullscreen();
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.mozCancelFullScreen) { /* Firefox */
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) { /* IE/Edge */
                    document.msExitFullscreen();
                }
            }
        }

        const isNext = this.props.data.gallery !== null
            ?   this.state.data.gallery.images[this.state.activeElement + 1]
                    ? false
                    : true
            :   true;

        const isFullscreen = this.state.fullscreen ? "fullscreen" : ""
        let array = []

        const toString = (object) => {
            Object.keys(object).map(function (key) { 
                object[key].name 
                    ? array.push([object[key].name ,object[key].url ])
                    : null
                // Using Number() to convert key to number type 
                // Using obj[key] to retrieve key value 
               // console.log(array);
                //console.log([Number(key), object[key]]); 
            }); 

            array.map((value, index) => {
                //console.log(value, index)
                return (
                    <div className="title">
                        <a href={value[1]}>{value[0]}</a>
                    </div>
                )
                //console.log(value, index)
            })
        }

        const table_under = () => {
            if(this.props.data.field.length !== 0) {
                return (
                    <div>
                        {this.props.data.field.persons 
                            ?   <div className="block__text--wrapper" >
                                    <h3 className="title">
                                        {this.props.data.field.persons.label}
                                    </h3>
                                    <div className="text">
                                        {Object.entries(this.props.data.field.persons).map(([key, value]) => {
                                            return (
                                                value.url !== null && value.url !== undefined
                                                    ? key > 0 
                                                        ? <span>, <a href={value.url}>{`${value.name}`}</a></span>
                                                        : <a href={value.url}>{`${value.name}`}</a>
                                                    : value.name 
                                                        ? key > 0
                                                            ? <span>{`, ${value.name}`}</span>
                                                            : <span>{`${value.name}`}</span>
                                                        : null
                                            )
                                        })}    
                                    </div>
                                </div>
                            : null
                        }
                        {this.props.data.field.institutions 
                            ?   <div className="block__text--wrapper" >
                                    <h3 className="title">
                                        {this.props.data.field.institutions.label}
                                    </h3>
                                    <div className="text">
                                        {Object.entries(this.props.data.field.institutions).map(([key, value]) => {
                                            return (
                                                value.url !== null && value.url !== undefined
                                                    ? key > 0 
                                                        ? <span>, <a href={value.url}>{`${value.name}`}</a></span>
                                                        : <a href={value.url}>{`${value.name}`}</a>
                                                    : value.name 
                                                        ? key > 0
                                                            ? <span>{`, ${value.name}`}</span>
                                                            : <span>{`${value.name}`}</span>
                                                        : null
                                            )
                                        })}    
                                    </div>
                                </div>
                            : null
                        }
                    </div>
                )
            } else if(this.props.data.string.length !== 0) {
                return (
                    <div>
                        {Object.entries(this.props.data.string).map(([key, value]) => {
                            if(value[0] !== "") {
                                return (
                                    <div key={key} className="block__text--wrapper">
                                        <h3 className="title">
                                            {value.label}
                                        </h3>
                                        <div className="text">
                                            <span>{value[0]}</span>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                )    
            }
        }

        return (
            <div id="mediaViewer">
                <h1>{this.props.data.title}</h1>
                {this.props.data.gallery !== null ? (
                    this.props.data.gallery.images && this.props.data.gallery.images.length > 0 ? (
                        <div className={`main-wrapper ${isFullscreen}`}>
                            <div className="galleries">
                                <div>
                                    <h3>{this.props.data.gallery.name}</h3>
                                    <div className="gallery">

                                        {this.props.data.gallery.images && this.props.data.gallery.images.length > 0 ? (
                                                this.props.data.gallery.images.map((image, imageKey)=>{
                                                    const active = imageKey == this.state.activeElement ? "active" : "";
                                                    if(imageKey == this.state.activeElement){

                                                    }
                                                    return(
                                                        <div onClick={changePhoto.bind(null, imageKey)} className={`image ${active} `} key={imageKey} style={{ backgroundImage: `url(${image.image})` }} />
                                                    )
                                                })
                                            ) : null}
                                    </div>
                                </div>
                            </div>
                            <div className={`viewer ${this.props.data.horizontal ? "horizontal" : ""}`} onWheelCapture={resizeImage} onMouseLeave={endResizeImage} onMouseDown={startMovingImage} onMouseUp={stopMovingImage}>
                                <div className="actions-wrapper">
                                    <div>
                                        <button className="zoom zoom-in" onClick={zoomIn}></button>
                                        <button className="zoom zoom-out" onClick={zoomOut}></button>
                                    </div>
                                    <div>
                                        <button onClick={zoomReset} style={{ fontSize: "14px", paddingBottom: "6px", borderRadius: "5px" }}>Reset</button>
                                    </div>
                                </div>
                                <div
                                    className="zoom-image"
                                    id="zoom-image"
                                    style={{
                                        backgroundImage: `url(${mainPhotoUrl}`,
                                        backgroundSize: `auto ${100*this.state.zoom}%`,
                                        backgroundPositionY: `calc(${this.state.positionY}% - ${this.state.changeY}px)`,
                                        backgroundPositionX: `calc(${this.state.positionX}% - ${this.state.changeX}px)`,
                                    }}>
                                </div>
                                <button disabled={this.state.activeElement == 0} onClick={prevImg} className="nav-btn left"></button>
                                <button disabled={isNext} onClick={nextImg} className="nav-btn right"></button>
                                <button className="toggle-fullscreen" onClick={toggleFullscreen}></button>
                            </div>
                        </div>
                    ) : null
                ) : null}
                <div style={{ marginTop: "25px"}} className="vt22-title-text">
                    <p dangerouslySetInnerHTML={{ __html: this.props.data.description}}></p>
                </div>
                <div className="vt14-content vt2-title">
                    {table_under()}
                    {this.props.data.params
                        ?   <div>
                                {Object.entries(this.props.data.params).map(([key, value]) => {
                                    return (
                                        value.txt
                                        ?   <div className="block__text--wrapper" >
                                                <h3 className="title">
                                                    {value.label}
                                                </h3>
                                                <div className="text">
                                                    <span dangerouslySetInnerHTML={{ __html: value.txt }} />
                                                </div>
                                            </div>
                                        : null
                                    )
                                })}
                            </div>
                        : null
                    }
                    {this.state.data.blocks ?
                        (this.state.data.blocks.map((block, index) => {
                            return (
                                <div className="block__text--wrapper">
                                    <h3 className="title" dangerouslySetInnerHTML={{ __html: block.label }} />
                                    <div className="text" dangerouslySetInnerHTML={{ __html: block.txt }} />
                                </div>)
                        }))
                        : null}

                    {this.state.data.humdrum_data && this.state.data.humdrum_data.length ? (
                        <div className="block__text--wrapper">
                            <h3 className="title">{musicLabel}</h3>
                            <ul>
                                {this.state.data.humdrum_data.map((item, index) =>
                                    <li key={index}><a target="_blank" href={item.url}>{item.name}</a></li>
                                )}
                            </ul>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Elements/MediaViewer/index.jsx